import _sortBy from 'lodash/sortBy';
var getDefaultPhone = function (phones) {
    var sorted = _sortBy(phones.filter(function (x) { return x; }), ['storage.unit', 'storage.size']);
    return sorted[0];
};
export default getDefaultPhone;
